export enum FilePreviewAction {
    DELETE,
    SAVE
}
